<template>
    <ul class="ivu-dropdown-menu" @click="handleClick"><slot></slot></ul>
</template>
<script>
import { findComponentUpward } from '../../utils/assist'
export default {
  name: 'CxDropdownMenu',
  props: {
    clickHide: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClick() {
      if (!this.clickHide) return
      const $parent = findComponentUpward(this, 'CxDropdown')
      const hasChildren = this.$parent && this.$parent.$options.name === 'CxDropdown'

      if (this.disabled) {
        this.$nextTick(() => {
          $parent.currentVisible = true
        })
      } else if (hasChildren) {
        this.$parent.$emit('on-haschild-click')
      } else {
        if ($parent && $parent.$options.name === 'CxDropdown') {
          $parent.$emit('on-hover-click')
        }
      }
      $parent.$emit('on-click', this.name)
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Dropdown/dropdown-menu.vue